import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <rect
      width={9}
      height={1.5}
      x={12.75}
      y={7.5}
      fill={props.fill || "#111"}
      rx={0.75}
      transform="rotate(90 12.75 7.5)"
    />
    <rect
      width={9}
      height={1.5}
      x={16.5}
      y={12.75}
      fill={props.fill || "#111"}
      rx={0.75}
      transform="rotate(-180 16.5 12.75)"
    />
  </svg>
)
export default SvgComponent
